/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Displays access denied message for unauthorized users. Handles
redirection and provides information about required permissions.
*/

import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const RestrictedPage: React.FC = () => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    // Optionally, redirect to login page if needed
    // window.location.href = "/auth";
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="mx-auto flex max-w-[420px] flex-col items-center justify-center text-center">
        <ShieldAlert className="h-12 w-12 text-destructive" />
        <h1 className="mt-6 text-2xl font-semibold tracking-tight">
          Restricted Access
        </h1>
        <p className="mt-2 text-muted-foreground">
          This area is restricted to administrators only. If you believe you should have access,
          please contact your system administrator.
        </p>
        <Button asChild className="mt-4">
          <Link to="/auth">Return to Login</Link>
        </Button>
        <Button variant="outline" className="mt-2" onClick={handleLogout}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default RestrictedPage;
